var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.74146 12.9023C10.0552 12.9023 12.7415 10.2161 12.7415 6.90234C12.7415 3.58864 10.0552 0.902344 6.74146 0.902344C3.42775 0.902344 0.741455 3.58864 0.741455 6.90234C0.741455 10.2161 3.42775 12.9023 6.74146 12.9023Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.2585 17.8174L11.2585 11.8174",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchGray);
export default __webpack_public_path__ + "static/media/ic_search_gray.1d7d82f272d98f677abe4c80a5eb3d7c.svg";
export { ForwardRef as ReactComponent };